import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  // 예시 세션 정보 (실제로는 API나 전역 상태관리 라이브러리 사용)
  const user = sessionStorage.getItem("ssuser"); // 사용자 정보 확인 (localStorage/sessionStorage 예시)

  // 세션에 사용자 정보가 없으면 로그인 화면으로 리디렉션
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // 세션에 사용자 정보가 있으면 접근 허용
  return <>{children}</>;
};

export default PrivateRoute;
